import { isApplicationMode } from '@repo/env-variables';
import type { MapType } from '@repo/map';
import { createStore } from '@repo/zustand';

interface State {
  mapType: MapType;
  setMapType: (mapType: MapType) => void;
  resetMapType: () => void;
}

const DEFAULT_MAP_TYPE: MapType = 'roadmap';

// Deliberately not persisted: the map type resets to roadmap on every mount of
// the map screen, so a satellite session never leaks into the next one.
export const useMapTypeStore = createStore<State>({
  name: 'MapTypeStore',
  isDev: isApplicationMode('dev'),
})((set) => ({
  mapType: DEFAULT_MAP_TYPE,
  setMapType: (mapType: MapType) => set({ mapType }),
  resetMapType: () => set({ mapType: DEFAULT_MAP_TYPE }),
}));
